import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { FaEnvelope, FaGlobe } from "react-icons/fa";

// ⬇️ Your Make webhook (visible in frontend)
const MAKE_WEBHOOK_URL = "https://hook.eu2.make.com/4uk1ptbkntumghnp840obaf5dbcke3k1";

const Contact = () => {
  const [formStatus, setFormStatus] = useState(null); // 'success' | 'error' | null
  const [loading, setLoading] = useState(false);
  const [isConsentGiven, setIsConsentGiven] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFormStatus(null);

    const form = e.target;
    const name = form.elements["name"].value.trim();
    const email = form.elements["email"].value.trim();
    const reason = form.elements["reason"].value;
    const subject = form.elements["subject"].value.trim();
    const message = form.elements["message"].value.trim();

const hp = form.elements["hp_field_zz9"]?.value?.trim() || "";
if (hp !== "") {
  console.warn("Honeypot triggered; aborting submit.");
  setLoading(false);
  return;
}


    const consentMarketing = isConsentGiven ? "on" : "off";

    // Payloads
    const apiPayload = { name, email, reason, subject, message };
const makePayload = {
  full_name: name,
  email,
  form_type: reason,
  subject,
  message,
  consent_marketing: consentMarketing,
  // website, // ❌ remove this line
  // Optional: send for diagnostics (safe to omit)
  honeypot: hp,                     // ✅ optional
  page_url: window.location.href,
  source: "AnalizyIRaporty.pl",
};

    try {
      const [apiRes, makeRes] = await Promise.allSettled([
        fetch("https://server229256.nazwa.pl/api/contact", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(apiPayload),
        }),
        fetch(MAKE_WEBHOOK_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(makePayload),
        }),
      ]);

      const apiOk = apiRes.status === "fulfilled" && apiRes.value.ok;

      if (apiOk) {
        setFormStatus("success");
        form.reset(); // resets fields back to initial state; Select returns to defaultValue
        setIsConsentGiven(false);
      } else {
        setFormStatus("error");
      }

      // Webhook is best-effort; don't block UX on its failure
      if (!(makeRes.status === "fulfilled" && makeRes.value.ok)) {
        console.warn("MAKE webhook failed or returned non-OK.");
      }
    } catch (err) {
      console.error("Error sending contact form:", err);
      setFormStatus("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContactContainer>
      <Header>Kontakt</Header>

      <ContactLayout>
        <LeftColumn>
          <ContactItem>
            <IconContainer>
              <FaEnvelope />
            </IconContainer>
            <Text>
              <strong>Adres e-mail:</strong>
              <br />
              <a href="mailto:biuro@analizyiraporty.pl">biuro@analizyiraporty.pl</a>
            </Text>
          </ContactItem>

          <ContactItem>
            <IconContainer>
              <FaGlobe />
            </IconContainer>
            <Text>
              <strong>Strona www:</strong>
              <br />
              <a
                href="https://www.analizyiraporty.pl/"
                target="_blank"
                rel="noopener noreferrer"
              >
                analizyiraporty.pl
              </a>
            </Text>
          </ContactItem>
        </LeftColumn>

        <RightColumn>
          <Form id="contact-form" onSubmit={handleSubmit}>
            {/* Honeypot (anti-bot) */}
<input
  type="text"
  name="hp_field_zz9"              // ← NEW NAME
  autoComplete="new-password"      // ← discourages autofill
  tabIndex="-1"
  aria-hidden="true"
  style={{ position: "absolute", left: "-9999px", top: "-9999px" }} // off-screen
/>

            <FieldGroup>
              <Label>Imię i nazwisko</Label>
              <Input
                name="name"
                type="text"
                placeholder="Wpisz swoje imię i nazwisko"
                required
              />
            </FieldGroup>

            <FieldGroup>
              <Label>Email</Label>
              <Input
                name="email"
                type="email"
                placeholder="Wpisz swój email"
                required
              />
            </FieldGroup>

            <FieldGroup>
              <Label>Powód kontaktu</Label>
              <Select name="reason" required defaultValue="partner">
                <option value="demo">Zarezerwuj DEMO</option>
                <option value="problem">Zgłoszenie problemu</option>
                <option value="info">Zapytanie o informacje</option>
                <option value="partner">Partner</option>
              </Select>
            </FieldGroup>

            <FieldGroup>
              <Label>Temat</Label>
              <Input
                name="subject"
                type="text"
                placeholder="Temat wiadomości"
                required
              />
            </FieldGroup>

            <FieldGroup>
              <Label>Wiadomość</Label>
              <Textarea
                name="message"
                rows="5"
                placeholder="Twoja wiadomość..."
                required
              />
            </FieldGroup>

            <FieldGroup>
              <label>
                <input
                  type="checkbox"
                  name="consent_marketing"
                  checked={isConsentGiven}
                  onChange={(e) => setIsConsentGiven(e.target.checked)}
                  required
                />{" "}
                Wyrażam zgodę na przetwarzanie moich danych osobowych zgodnie z{" "}
                <EmailLink
                  href="/polityka-prywatnosci.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  polityką prywatności
                </EmailLink>
                .
              </label>
            </FieldGroup>

            <SubmitButton type="submit" disabled={loading || !isConsentGiven}>
              {loading ? "Wysyłanie..." : "Wyślij wiadomość"}
            </SubmitButton>

            {formStatus === "success" && (
              <Message $success>Wiadomość została pomyślnie wysłana!</Message>
            )}
            {formStatus === "error" && (
              <Message $success={false}>
                Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.
              </Message>
            )}
          </Form>
        </RightColumn>
      </ContactLayout>
    </ContactContainer>
  );
};

export default Contact;

/* ===================== Styled Components ===================== */

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const ContactContainer = styled.div`
  text-align: center;
  padding: 5rem 2rem;
  background: url("/back.jpg") no-repeat center center fixed;
  background-size: cover;
  position: relative;
  animation: ${fadeIn} 1s ease-out;
`;

const Header = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #1f2937;
  margin-bottom: 2rem;
`;

const ContactLayout = styled.div`
  display: flex;
  gap: 3rem;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const LeftColumn = styled.div`
  flex: 1;
  min-width: 280px;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const RightColumn = styled.div`
  flex: 1;
  min-width: 300px;
  max-width: 700px;
`;

const ContactItem = styled.div`
  padding: 2rem;
  max-width: 400px;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    max-width: 100%;
    text-align: left;
  }
`;

const IconContainer = styled.div`
  font-size: 2rem;
  color: #03ecfc;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  font-size: 1rem;
  color: #374151;

  a {
    color: #6366f1;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

const Label = styled.label`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1f2937;
  text-align: left;
`;

const Input = styled.input`
  flex: 1;
  padding: 0.8rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  color: #111827;
  background-color: #f9fafb;
  outline: none;

  &:focus {
    border-color: #3bc3cc;
    box-shadow: 0 0 0 2px rgba(59, 195, 204, 0.2);
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  padding: 0.8rem 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 1rem;
  color: #111827;
  background-color: #f9fafb;
  resize: vertical;
  outline: none;
  margin-bottom: 1rem;

  &:focus {
    border-color: #3bc3cc;
    box-shadow: 0 0 0 2px rgba(59, 195, 204, 0.2);
  }
`;

const Select = styled.select`
  padding: 0.75rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 1rem;
  background-color: white;
  transition: 0.2s ease;

  &:focus {
    border-color: #3bc3cc;
    outline: none;
    box-shadow: 0 0 0 3px rgba(59, 195, 204, 0.2);
  }
`;

const SubmitButton = styled.button`
  background-color: #3bc3cc;
  color: white;
  padding: 0.9rem 2rem;
  border: none;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #111827;
    transform: scale(1.05);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
  }
`;

const EmailLink = styled.a`
  color: #3bc3cc;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Message = styled.p`
  margin-top: 1rem;
  font-weight: 600;
  color: ${({ $success }) => ($success ? "#10b981" : "#ef4444")};
  background: ${({ $success }) => ($success ? "#ecfdf5" : "#fef2f2")};
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid ${({ $success }) => ($success ? "#10b981" : "#ef4444")};
  text-align: center;
  animation: ${fadeIn} 0.4s ease-in-out;
`;
